import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePatientMutation } from '../../api/patient/usePatientMutation';
import { FormError } from '../form/FormError';
import { TextField } from "@mui/material";
const formatPhone = (input) => {
    const digits = input.replace(/\D/g, '').slice(0, 10);
    if (digits.length < 4)
        return digits;
    if (digits.length < 7)
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};
export const PatientInlinePhoneForm = (props) => {
    const { onComplete, initialValue, patientId, initialEditing } = props;
    const [isEditing, setIsEditing] = useState(initialEditing);
    const { mutateAsync } = usePatientMutation();
    const { handleSubmit, register, formState: { errors }, watch, setValue, clearErrors } = useForm({
        defaultValues: {
            phone: formatPhone(initialValue),
        },
    });
    const { phone } = watch();
    const handlePhoneChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        const formatted = formatPhone(raw);
        setValue('phone', formatted, { shouldValidate: true });
        if (raw.length === 10)
            clearErrors('phone');
    };
    const onSubmit = async (data) => {
        if (data.phone !== initialValue) {
            if (data.phone === '') {
                data.phone = 'null';
                await mutateAsync({ patientId, ...data });
                data.phone = '';
            }
            else {
                await mutateAsync({ patientId, ...data });
            }
            onComplete(data.phone);
        }
    };
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true, style: { borderRadius: '4px', border: isEditing ? '1px solid #2C78EB' : 'none', padding: isEditing ? '5px' : '0px' } },
        React.createElement("div", { className: "text-sm flex items-center", style: { height: '30px' } },
            React.createElement(TextField, { ...register('phone', {
                    pattern: {
                        value: /^\d{3}-\d{3}-\d{4}$/,
                        message: 'Invalid phone number',
                    }
                }), id: "user-phone", variant: 'standard', style: { fontSize: 11, color: 'rgba(0, 0, 0, 0.87)', fontFamily: 'Barlow', fontWeight: '400', width: '100%', verticalAlign: 'middle' }, size: 'small', inputProps: { style: { height: '10px', fontSize: 12 } }, placeholder: 'XXX-XXX-XXXX', onClick: () => setIsEditing(true), InputProps: {
                    disableUnderline: true,
                    readOnly: !isEditing,
                    inputMode: 'numeric',
                }, onBlur: (e) => {
                    const currentValue = e.target.value;
                    setIsEditing(false);
                    if (currentValue !== initialValue) {
                        handleSubmit(onSubmit)();
                    }
                    else {
                        props.onCancel();
                    }
                }, value: phone, onChange: handlePhoneChange })),
        React.createElement(FormError, { errors: errors, name: "phone", className: "font-bold text-app-red-dark block text-xxs mt-1" })));
};
